<template>
  <div class="terms-of-service-page mt-[30px] md:mt-0">
    <SecondaryHero
      :heading="$t('pages.termsOfService.heroHeading')"
      :text="$t('pages.termsOfService.heroText')"
      background-image="/top.svg"
    />
    <WysiwygContent class="mx-auto my-16 max-w-[800px]">
      <h3>TERM &amp; CONDITIONS</h3>
      <h4>FREE TOURS</h4>
      <p>
        Free Tours operate regularly (fixed days, hours and meeting points) and
        are designed especially for enjoyment of individual travellers and small
        groups (fewer than 7). They run on a tip-based base only. There is no
        fixed in advance price, there are no costs to join the tour. Even though
        it is not necessary to book free tours we strongly advise doing so. Only
        this way we can be prepared for big groups and send more guides to the
        meeting point to make sure that our guests will enjoy sightseeing in
        relatively small groups. We suggest coming about 10, but no less than 5,
        minutes before the tour’s starting time.
      </p>
      <h4>PAID TOURS</h4>
      <p>
        Paid tours are regular tours with fixed prices. We strongly advise
        booking your place on paid tours in advance. This is the only way we can
        guarantee you will be served. If there are available places, spots will
        be allocated to those who did not pre-book on a first come, first served
        basis. Your ticket and booking confirmation will be sent to you
        automatically by email upon your successful order. If you do not receive
        it, please contact us at info@walkative.eu, as it may mean your order
        has not been successfully processed. Please check your junk or spam
        folder first. You should print your ticket or be able to present it on
        smartphone or tablet. You may be also asked to show a valid photo ID to
        identify yourself. We have to verify your booking for you to be able to
        access the tour. You can either pay for the tour online with your card
        or on the spot with cash. After you’ve booked the tour, we ask you to
        arrive at the meeting point no later than 10 minutes before the start of
        the tour. After this, we reserve the right to allocate your place to
        somebody else. We do this to ensure we treat all those wishing to
        participate fairly, as well as to ensure a punctual start for the tour.
        In case of reduced tickets, if you are unable to prove your student
        status or are not under the age of 18 and traveling with a parent or
        guardian, you may be asked to pay the difference between a student and a
        regular ticket. We ask participants to stay with their group for the
        entire duration of the tour and to follow the guide’s instructions.
        Leaving the group or interrupting the tour does not entitle you to a
        refund.
      </p>
      <h4>PRIVATE TOURS</h4>
      <p>
        For those who do not wish or cannot join free or paid tours, we can
        provide private tours. Their topics, starting time and starting point
        can be set in a way it suits the travellers best. If you book your
        private guide online, your ticket and booking confirmation will be sent
        to you automatically by email upon successful order. If you do not
        receive it, please contact us at info@walkative.eu as it may mean that
        your order has not been successfully processed. Please check your junk
        or spam folder first. You should be ready to print your ticket or to
        show it on your smartphone or tablet. You may be also asked to show a
        valid ID with picture to identify yourself. The number of participants
        is limited to a maximum of 35 people per one guide, unless specified
        differently. Groups with more than 35 participants will need to book
        more than one private tour guide. Your tour ticket includes your private
        tour guide(s). Anything else not specifically included in the tour price
        is not included. We ask participants to stay with their group for the
        entire tour and to follow the guide’s instructions. Leaving the group or
        interrupting the tour does not entitle you to a refund.
      </p>
      <h4>GROUPS</h4>
      <p>
        For groups starting from 8 persons travelling together, we have a group
        offer. Contact our office for details.
      </p>
      <h4>ONLINE PAYMENTS</h4>
      <p>
        Online payments are done using PayPal. You can do it either via your
        PayPal account or using your credit or debit card. In case of refund the
        money will be wired to your PayPal account or to your card account
        within 14 days.
      </p>
      <h4>CANCELLATIONS</h4>
      <p>
        You may cancel your booking any time before the tour date by writing an
        email to info@walkative.eu. Cancellations done at least 48 hrs before
        the start of the tour are free of charge. A 50% refund will be given to
        cancellations received between 48-12 hours before the start of your
        private tour. Cancellations received within 12 hours and no-shows will
        not be refunded.
      </p>
      <h4>LATE POLICY</h4>
      <p>
        During private and group tours guide is booked for a specific length of
        time. If your group arrives more than 10 minutes late, the waiting time
        will be deducted from the agreed tour length. If you are running late,
        please contact us at (+48) 513 875 814 or a designed guide’s number (if
        provided). If no contact is made within 15 minutes after the agreed
        meeting time, the group will be considered a “no-show” and the tour will
        be cancelled with no refunds.
      </p>
      <h4>CANCELLATIONS - OUR FAULT</h4>
      <p>
        We do all we can to make sure that all tours run as scheduled. However,
        in the event the tour is cancelled without prior notification and it is
        the fault of Walkative! or one of our guides, we will refund your
        pre-paid ticket as well as offer up to 100% of the value of the original
        ticket price as credit towards the purchase of another tour as
        compensation. This credit cannot be used in any other way and will not
        be cashable.
      </p>
      <h4>REFUNDS</h4>
      <p>
        We have a no refund policy, unless the cancelation of your tour was by
        our fault. In such a case, we will refund you with the total amount you
        have paid. The money will be wired to your PayPal account or to your
        card account within 14 days.
      </p>
      <h4>ACTS OF GOD</h4>
      <p>
        Walkative! will not be held responsible if the scheduled tour is
        cancelled due to Acts of God, (extreme weather, severe storms, violent
        windstorms, etc.).
      </p>
      <h4>DENYING PARTICIPATION</h4>
      <p>
        Participation in tours organized by Walkative! is strictly voluntary,
        and your guide and the company reserve the right to deny participation
        to anybody for any reason at any time (for example being under influence
        of alcohol or narcotics, being offensive or rude etc.)
      </p>
      <h4>RISK</h4>
      <p>
        When organising our tours, we do our best to keep risk to a minimum.
        However there are things we cannot control. Therefore, Walkative! and
        its partners and employees assume no liability or responsibility for any
        injury, loss, damage or inconvenience sustained by any person using its
        services, nor to their property.
      </p>
      <h4>UNDER AGE PARTICIPANTS</h4>
      <p>
        All guests aged 17 and under joining any Walkative! tours must be
        accompanied by an adult, who must remain with the group until tour ends.
        Guests aged 7-15 yrs can join the regular paid tours and pay 50% of the
        costs, children aged 0-6 yrs may join regular paid tours free of charge.
        They may be asked to cover costs associated with tours such as tram or
        train tickets, museum entry, food etc. No guest under the age of 18 may
        join our Beer Tours or drink alcohol on Food Tours.
      </p>
      <h4>PRIVACY</h4>
      <p>
        Walkative! collects some data from our guests and reserves the right to
        use some of it for marketing and research purposes only. We will never
        sell data entrusted to us to any third party.
      </p>
      <h4>FORGOTTEN ITEMS</h4>
      <p>
        We are not liable for items forgotten in buses, boats, or visited sites.
      </p>
      <h4>CHANGES</h4>
      <p>
        Please note that any changes to the tours programme due to unexpected
        changes in opening hours of the visited sites or traffic restrictions
        are reserved.
      </p>
      <h4>DRINKING AND SMOKING</h4>
      <p>Drinking and smoking is prohibited during all Walkative! tours.</p>
    </WysiwygContent>
  </div>
</template>

<script lang="ts" setup>
const config = useRuntimeConfig();
const { t, locale, locales, defaultLocale } = useI18n();

const metaTitle = computed(() => t("pages.termsOfService.seo_title"));
const metaDescription = computed(() =>
  t("pages.termsOfService.seo_meta_description"),
);

useHead({
  title: metaTitle.value,
  meta: [{ name: "description", content: metaDescription.value }],
  link: generateSEOLinks(
    locales.value,
    defaultLocale,
    locale.value,
    config.public.websiteUrl,
    [
      {
        en: "terms-of-service",
        es: "terminos-de-servicio",
        de: "terms-of-service",
        pl: "warunki-korzystania-z-uslug",
      },
    ],
  ),
});

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: "/terms-of-service",
    es: "/terminos-de-servicio",
    de: "/terms-of-service",
    pl: "/warunki-korzystania-z-uslug",
  },
});
</script>
